import { useTranslation } from 'react-i18next';
import { environment } from '@/config/environment';
import { Icon } from '@/components/common/Icon';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';

export function ReviewCard() {
  const { t } = useTranslation('clients');
  const reviewUrl = environment.googleReviewUrl;
  if (reviewUrl.trim().length === 0) {
    return null;
  }
  return (
    <Card as="section">
      <div className="flex items-center gap-2 mb-2">
        <span className="w-9 h-9 rounded-xl bg-zoovpalelavender text-zooviolet flex items-center justify-center shrink-0">
          <Icon name="Star" />
        </span>
        <h2 className="text-sm font-bold text-zooindigo">{t('portal.reviewTitle')}</h2>
      </div>
      <p className="text-xs text-zoomuted mb-3">{t('portal.reviewDescription')}</p>
      <Button asChild variant="outline" size="chip" className="w-full">
        <a href={reviewUrl} target="_blank" rel="noopener noreferrer">
          <Icon name="Star" />
          {t('portal.reviewAction')}
        </a>
      </Button>
    </Card>
  );
}
